module.exports = __webpack_public_path__ + "img/summary-hired-count.e88d6f55.svg";